'use client';

import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { api, unwrapApiResponse } from '@/utils/api';

const SiteConfigContext = createContext<{ requireVipToAccess: boolean; loading: boolean }>({
  requireVipToAccess: false,
  loading: true,
});

export function SiteConfigProvider(props: { children: ReactNode }) {
  const [requireVipToAccess, setRequireVipToAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('config/site-mode')
      .then((res) => {
        const data = unwrapApiResponse<{ isPublic?: boolean }>(res);
        // isPublic=true  → site aberto → requireVipToAccess=false
        // isPublic=false → site fechado → requireVipToAccess=true
        setRequireVipToAccess(data?.isPublic === false);
      })
      .catch(() => setRequireVipToAccess(false))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteConfigContext.Provider value={{ requireVipToAccess, loading }}>
      {props.children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}

export default SiteConfigProvider;
